var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _Basic = require("../../../elements/Basic");

var _Body = _interopRequireDefault(require("./Body"));

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _Logos = require("../Basic/Logos");

var _withDataRefresh = _interopRequireDefault(require("../../../hoc/withDataRefresh"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Article/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Article = function (_React$Component) {
  (0, _inherits2.default)(Article, _React$Component);

  var _super = _createSuper(Article);

  function Article() {
    (0, _classCallCheck2.default)(this, Article);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Article, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          article = _this$props.article,
          refreshing = _this$props.refreshing,
          onRefresh = _this$props.onRefresh;
      return _react.default.createElement(_Basic.ScrollView, {
        refreshControl: _react.default.createElement(_Basic.RefreshControl, {
          refreshing: refreshing,
          onRefresh: onRefresh,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 33
          }
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22,
          columnNumber: 13
        }
      }, !(0, _isEmpty.default)(article) ? _react.default.createElement(_react.default.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.Row, {
        flexing: true,
        center: true,
        mb: 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27,
          columnNumber: 25
        }
      }, article.authors && article.authors.length ? article.authors.map(function (author) {
        return _react.default.createElement(_Basic.Text, {
          size: "small",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 30,
            columnNumber: 39
          }
        }, (0, _i18n.default)('source_prefix'), " ", author.firstName, ' ', author.lastName);
      }) : null, article.authors && article.authors.length && article.publishedAt ? _react.default.createElement(_Basic.Text, {
        ml: 1,
        size: "small",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 38,
          columnNumber: 33
        }
      }, "|") : null, article.publishedAt ? _react.default.createElement(_Basic.Text, {
        ml: 1,
        size: "small",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 33
        }
      }, (0, _moment.default)(article.publishedAt).format('L') + " - " + (0, _moment.default)(article.publishedAt).format('LT')) : null), article.headline ? _react.default.createElement(_Basic.View, {
        flexing: true,
        center: true,
        mb: 2,
        mx: 4,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52,
          columnNumber: 29
        }
      }, _react.default.createElement(_Basic.Text, {
        bold: true,
        size: "large",
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 33
        }
      }, article.headline)) : null, article.subHeadline ? _react.default.createElement(_Basic.View, {
        flexing: true,
        center: true,
        mb: 4,
        px: 4,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 29
        }
      }, _react.default.createElement(_Basic.Text, {
        center: true,
        size: "medium",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61,
          columnNumber: 33
        }
      }, article.subHeadline)) : null, article.mainImage ? _react.default.createElement(_Basic.View, {
        mb: 4,
        position: "relative",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68,
          columnNumber: 29
        }
      }, _react.default.createElement(_Logos.TeaserImage, {
        src: article.mainImage,
        width: "100%",
        aspectRatio: 18 / 10,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 33
        }
      }), article.copyright ? _react.default.createElement(_Basic.View, {
        position: "absolute",
        right: 6,
        bottom: 0,
        bg: "transparent",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 37
        }
      }, _react.default.createElement(_Basic.Text, {
        size: "small",
        color: "white",
        style: {
          textShadowColor: 'rgba(0, 0, 0, 0.75)',
          textShadowOffset: {
            width: 0,
            height: 1
          },
          textShadowRadius: 4
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76,
          columnNumber: 41
        }
      }, "\xA9", " ", article.copyright)) : null) : null, article.abstract ? _react.default.createElement(_Basic.View, {
        mx: 4,
        flexing: true,
        mb: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 29
        }
      }, _react.default.createElement(_Basic.Text, {
        bold: true,
        size: "medium",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94,
          columnNumber: 33
        }
      }, article.abstract)) : null, article.text ? _react.default.createElement(_Basic.View, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101,
          columnNumber: 29
        }
      }, _react.default.createElement(_Body.default, {
        text: article.text,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102,
          columnNumber: 33
        }
      })) : null) : null);
    }
  }]);
  return Article;
}(_react.default.Component);

Article.propTypes = {
  article: _propTypes.default.object.isRequired,
  refreshing: _propTypes.default.bool,
  onRefresh: _propTypes.default.func
};

var _default = (0, _withDataRefresh.default)(Article);

exports.default = _default;